var path = 'app/productConfig/productConfig.tpl.html';
var html = "<button class=\"btn btn-primary btn-{{$ctrl.buttonSize}}\" ng-click=$ctrl.configModal() aria-describedby={{$ctrl.describedBy}}> {{$ctrl.buttonLabel}} </button> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;